import React, { useEffect, useState } from "react";
import {
  AvatarHeaderDiv,
  AvatarHeaderDiv_Image,
  NameDiv,
} from "./AvatarHeader.Style";
import {
  SPECIFIC_USER_FAILURE,
  SPECIFIC_USER_SUCCESS,
  SPECIFIC_USER_START,
} from "../../../container/user/types";
import { userSpecificService } from "../../../services/UserService";
import { useStore } from "../../../store";
import DFS from "../../../assets/images/df.png";
import { Link, useLocation } from "react-router-dom";
import Avatar from "../../Avatar/Avatar";
import { FaBell } from "react-icons/fa";
import {
  REACT_APP_IMG_BASE_URL,
  REACT_LOCAL_APP_IMG_BASE_URL,
} from "../../../ImageConst";
import Notification from "../../Notification/Notification";

const AvatarHeader: React.FC = () => {
  const [showNotification, SetShowNotification] = useState(false);
  const [state, dispatch]: any = useStore();
  const location = useLocation();

  useEffect(() => {
    dispatch({ type: SPECIFIC_USER_START });
    userSpecificService()
      .then((res: any) => {
        // console.log(res);
        dispatch({ type: SPECIFIC_USER_SUCCESS, specificUser: res });
      })
      .catch((err) => {
        dispatch({ type: SPECIFIC_USER_FAILURE, specificUserError: err });
      });
  }, []);

  const changeShowNotification = () => {
    SetShowNotification((prevState) => !prevState);
  };

  return (
    <AvatarHeaderDiv>
      <AvatarHeaderDiv_Image>
        {location.pathname === "userdashboard" ||
        location.pathname === "userdashboard/reports" ||
        location.pathname === "userdashboard/feedback" ? (
          <img
            className="imageCompanyLogo"
            src={`${REACT_APP_IMG_BASE_URL}${state?.userReducer?.specificUser?.company.image_url}`}
            alt="deerwalk foods logo"
            style={{ objectFit: "contain" }}
          />
        ) : (
          <Link to="/userdashboard" style={{ display: "flex" }}>
            <img
              className="imageCompanyLogo"
              src={`${REACT_APP_IMG_BASE_URL}${state?.userReducer?.specificUser?.company?.image_url}`}
              alt="deerwalk foods logo"
            />
            {/* <img
              src={DFS}
              className="providerCompanyLogo"
              alt="deerwalk foods logo"
              style={{
                paddingBottom: "10px",
                objectFit: "contain",
                marginLeft: "20px",
              }}
            /> */}
          </Link>
        )}
      </AvatarHeaderDiv_Image>
      <NameDiv>
        <div
          className="bellIConDiv"
          style={{ cursor: "pointer" }}
          onClick={changeShowNotification}
        >
          <FaBell color="#e6662c" className="bellICon" />
        </div>
        <div className="spanDivs  mr-3">
          <span
            className="fw-bold name"
            style={{ textTransform: "capitalize" }}
          >
            {state?.userReducer?.specificUser?.name}
          </span>
          <span className="id">
            ID: {state?.userReducer?.specificUser?.dfs_id}
          </span>
        </div>

        <Avatar
          userName={state?.userReducer?.specificUser?.name}
          src={state?.userReducer?.specificUser?.image_url}
          alt="Avatar"
          className="avatarContianer"
        />
      </NameDiv>

      {showNotification && (
        <div
          style={{
            zIndex: "6000",
            position: "absolute",
            right: "0",
            top: "10%",
          }}
        >
          <Notification />
        </div>
      )}
    </AvatarHeaderDiv>
  );
};

export default AvatarHeader;
